import { StyleSheet } from 'aphrodite';
import * as React from 'react';
import { useParams } from 'react-router';
import { IImpersonationContext } from '../../../extViewmodels';
import * as AdminViewModels from '../../../viewmodels/AdminViewModels';
import {
	AdminDrawerToolbar,
	AppDrawerToolbarButton,
	SideDrawer,
	StickyAppDrawerContent,
} from '../../../web/components-v2/Drawer/AppDrawer';
import { ScheduleMeetingIcon } from '../../../web/components/svgs/icons/ScheduleMeetingIcon';
import { SparklesIcon } from '../../../web/components/svgs/icons/SparklesIcon';
import {
	AdminAppAssistantChat,
	SuccessMeetingPrepAppAssistantChat,
} from '../../../web/containers/templates/AssistantChat';
import { ConditionalAccess } from '../../components/ConditionalAccess';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { AccountDetails } from '../../containers/account/AccountDetails';

const styles = StyleSheet.create({
	content: {
		minWidth: 1118,
	},
});

export const AdminAccountDetailsPage: React.FC = () => {
	const params = useParams<{ accountId: string }>();
	const impersonationContext: IImpersonationContext = { account: { id: params.accountId } };
	return (
		<AdminDashboardPageLayout
			contentStyles={[styles.content]}
			sidebarChildren={
				<SideDrawer>
					<StickyAppDrawerContent value='ai-assistant'>
						<AdminAppAssistantChat impersonationContext={impersonationContext} />
					</StickyAppDrawerContent>
					<StickyAppDrawerContent value='success-meeting-prep'>
						<SuccessMeetingPrepAppAssistantChat impersonationContext={impersonationContext} />
					</StickyAppDrawerContent>
					<AdminDrawerToolbar>
						<AppDrawerToolbarButton value='ai-assistant' tooltip='AI Assistant'>
							<SparklesIcon />
						</AppDrawerToolbarButton>
						<ConditionalAccess permission={AdminViewModels.AdminPermission.ModifyAccount}>
							<AppDrawerToolbarButton value='success-meeting-prep' tooltip='Prepare for Meeting'>
								<ScheduleMeetingIcon fill='currentColor' />
							</AppDrawerToolbarButton>
						</ConditionalAccess>
					</AdminDrawerToolbar>
				</SideDrawer>
			}
		>
			<AccountDetails />
		</AdminDashboardPageLayout>
	);
};
